module.exports = __webpack_public_path__ + "assets/fonts/Guroo-Producer.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/guroo-producer/fonts/Guroo-Producer.svg
 ** module id = 417
 ** module chunks = 0
 **/